module.exports = __webpack_public_path__ + "img/pd-img18.62d31e1d.png";